import React, { forwardRef, LegacyRef } from 'react'

import styles from '../style.module.less'
import { BaseIconProps } from '../types'

export const Setting = forwardRef(
  (
    { _width, _height, _fill, className, spin, rtl, ...rest }: BaseIconProps,
    root: LegacyRef<SVGSVGElement>
  ) => {
    return (
      <svg
        ref={root}
        width={_width}
        height={_height}
        viewBox="0 0 48 48"
        preserveAspectRatio="xMidYMid meet"
        fill="none"
        role="presentation"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ''} ${spin ? styles.spin : ''} ${
          rtl ? styles.rtl : ''
        }`.trim()}
        {...rest}
      >
        <g>
          <defs>
            <clipPath id="bb4cb__a">
              <rect
                rx="0"
                height="48"
                width="48"
              />
            </clipPath>
          </defs>
          <g
            clipPath="url(#bb4cb__a)"
            style={{ mixBlendMode: 'passthrough' }}
          >
            <path
              fillRule="evenodd"
              d="M16.712 6.197A3 3 0 0 1 19.602 4h8.48a3 3 0 0 1 2.89 2.197l1.023 3.682 3.7-.956a3 3 0 0 1 3.348 1.405l4.24 7.344a3 3 0 0 1-.458 3.602L40.15 24l2.676 2.726a3 3 0 0 1 .458 3.602l-4.24 7.344a3 3 0 0 1-3.348 1.405l-3.7-.956-1.023 3.682A3 3 0 0 1 28.082 44h-8.48a3 3 0 0 1-2.89-2.197l-1.023-3.681-3.7.955a3 3 0 0 1-3.347-1.405l-4.24-7.344a3 3 0 0 1 .457-3.602L7.536 24 4.86 21.274a3 3 0 0 1-.457-3.602l4.24-7.344a3 3 0 0 1 3.348-1.405l3.699.955 1.023-3.68ZM20.362 8l-1.082 3.895a3 3 0 0 1-3.64 2.102l-3.914-1.01-3.48 6.027 2.832 2.884a3 3 0 0 1 0 4.204l-2.832 2.884 3.48 6.028 3.914-1.01a3 3 0 0 1 3.64 2.101L20.362 40h6.96l1.082-3.895a3 3 0 0 1 3.64-2.102l3.915 1.01 3.48-6.027-2.833-2.884a3 3 0 0 1 0-4.204l2.833-2.884-3.48-6.028-3.915 1.011a3 3 0 0 1-3.64-2.102L27.322 8h-6.96Zm3.48 12a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm-8 4a8 8 0 1 1 16 0 8 8 0 0 1-16 0Z"
              style={{ mixBlendMode: 'passthrough' }}
              data-follow-fill="#475466"
              fill={_fill}
            />
          </g>
        </g>
      </svg>
    )
  }
)
